import { Typography } from '@material-ui/core';
import React, { Dispatch, SetStateAction, useState } from 'react';
import VoxelDialog from '../../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionCancel from '../../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../../components/voxel/Dialogs/VoxelDialogContent';
import { ContentKeywordGq } from '../../../../graphql/projects/models/ContentKeywordGq';
import { ContentTaskGq } from '../../../../graphql/projects/models/ContentTaskGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import { ContentTaskTableState } from '../Tables/ContentKeywordTable/logic/useContentTaskTableState';
import VoxelText from '../../../../components/voxel/Text/VoxelText';

export interface ContentKeywordsRemoveDialogProps {
  contentTask: ContentTaskGq;
  selectedCount: number;
  selectedKeywordIds: number[];
  tableState: ContentTaskTableState;
  setLocalItems: Dispatch<SetStateAction<ContentKeywordGq[]>>;
  reload: () => Promise<any>;
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
}

const ContentKeywordsRemoveDialog: React.FC<ContentKeywordsRemoveDialogProps> = ({
  contentTask,
  selectedCount,
  selectedKeywordIds,
  tableState,
  setLocalItems,
  reload,
  openDialog,
  setOpenDialog,
}) => {
  const [updating, setUpdating] = useState(false);

  // Mutation
  const archiveContentKeywordMutation =
    projectsApiService.mutations.contentPlan.useArchiveTaskKeywords();
  const handleArchiveContentKeywords = (contentTaskId: number, contentKeywordIds: number[]) => {
    setUpdating(true);
    setLocalItems((prev) => prev.filter((x) => !contentKeywordIds.includes(x.id)));
    archiveContentKeywordMutation({
      projectId: contentTask.projectId,
      contentTaskId: contentTaskId,
      contentKeywordIds: contentKeywordIds,
    })
      .then(reload)
      .finally(() => {
        setUpdating(false);
        tableState.handleResetSelection();
        setOpenDialog(false);
      });
  };

  return (
    <VoxelDialog
      maxWClass={'max-w-2xl'}
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      title="Remove from content plan"
    >
      <VoxelDialogContent>
        <VoxelText>
          Are you sure you want to remove{' '}
          <VoxelText variant='bread-semibold' span> {selectedCount} keywords </VoxelText>{' '}
          from the content plan? This action will also move the keywords to the archived folder.
        </VoxelText>
      </VoxelDialogContent>

      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={() => setOpenDialog(false)} disabled={updating} />
        <VoxelDialogActionSubmit
          title={'Remove'}
          onClick={() => {
            handleArchiveContentKeywords(contentTask.id, selectedKeywordIds);
          }}
          disabled={updating}
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default ContentKeywordsRemoveDialog;
